module.exports = __webpack_public_path__ + "media/images/backgrounds/intro_icon-2f7e73f8e9a9a6bfa91a5f9283abd238.svg";